import * as S from "../../Style/Page/Hat.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitle.js";
// const Factory1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/31. 캘리포니아주 스탁톤 본사.712f332f0a983157af21.jpg`;
// const Factory2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/32. 텍사스주 달라스 공장  밀라노.570c2ea1c1b38389f6a1.jpg`;
import Factory1 from "../../assets/SalesCorporation3/캘리포니아주 스탁톤 본사.png";
import Factory2 from "../../assets/SalesCorporation3/텍사스주 달라스 공장.png";
const Factory3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/33. 중국 상해 공장  SGA.edabf283966ba1f5ad8f.jpg`;
const Factory4 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/34. 멕시코 공장  훠거햇.2dec23f0a582c5051289.jpg`;
const Factory5 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/35. 멕시코 리테일샾  카보햇.298bab8542c0cb70edc8.jpg`;
const Hat1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/36. 미국법인 모자.3cc830eb07f7c67e849c.jpg`;
import HatPageTopLine from "../../Component/HatPageTopLine.js";
const SalesCorporation3 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"모자사업"} ename={"YoungAn Hat"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/HatBusiness/Introduce">
                <div className="kor">모자사업</div>
                <div className="eng">Hat Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/HatBusiness/SalesCorporation">
                <div className="kor">위탁경영사업장</div>
                <div className="eng">Indirect Management Affiliates</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/KoreaCompany">
                  <div className="kor">영안모자 한국본사</div>
                  <div className="eng">Korean Headquarters</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">직경영사업장</div>
                  <div className="eng">Direct Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">
                  <div className="kor">위탁경영사업장</div>
                  <div className="eng">Indirect Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/HatBusiness/SalesCorporation3">
                <div className="kor">돌프만퍼시픽 ㈜</div>
                <div className="eng">Dorfman Milano Company</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">AJM</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation2">
                  <div className="kor">아웃도아 캡 컴퍼니㈜</div>
                  <div className="eng">Outdoor Cap Co., Inc.</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation3">
                  <div className="kor">돌프만퍼시픽 ㈜</div>
                  <div className="eng">Dorfman Milano Company</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>

        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"해외 판매 / 생산 사업장"}
              titleeng={"Dorfman Milano Company"}
              website="https://dorfmanmilanohats.com/"/>
            <div className="page-text">
              <div className="kor">
                <h2>미국 법인 / Dorfman Milano Company</h2>
              </div>
              <div className="eng">
                <h2>U.S.A. company / Dorfman Milano Company</h2>
              </div>
            </div>

            <S.ImgHolderFullsize>
              <img src={Factory2} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">텍사스주 달라스 본사 / 밀라노 공장</div>
                  <div className="eng">Milano Hat / Factory in Dallas, Texas</div>
                </div>
            </S.ImgHolderFullsize>

            <S.ImgHolderFullsize>
              <img src={Factory1} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">캘리포니아주 스탁톤 지점</div>
                <div className="eng">Headquarters in Stockton, California</div>
              </div>
            </S.ImgHolderFullsize>


            <PageTitle titleko={"주요생산제품"} titleeng={"Major Production Products"} />
            <S.ImgHolderFlex className="center">
              <img src={Hat1} alt="" />
            </S.ImgHolderFlex>
            <PageTitle titleko={"주요이력"} titleeng={"Major History"} />

            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor"><h2>Dorfman Milano Company 법인개요</h2></div>
                    <div className="eng"><h2>Company Profile of Dorfman Milano Company</h2></div>
                  </div>
                  <div className="kor">
                    법인 설립: 1921년
                    <br />
                    영안 합자: 1993년
                    <br />
                    
                    Mliano Hat Co., Inc.(밀라노햇) 합병: 2004년
                  </div>
                  <div className="eng">
                    Establishment : 1921
                    <br />
                    Joint venture with YoungAn : 1993
                    <br />
                    Merged with Milano Hat Co., Inc. : 2004
                  </div>
                </div>
              </div>
              <div className="kor">
                ※ 텍사스주 달라스 본사 / 캘리포니아주 스탁톤 지점
                <br />
                ※ 종합모자 판매업체
                <br />
                ※ 다양한 브랜드의 패션제품(햇 류)을 미국 포함, 전 세계 리테일시장에 판매
                <br />
                ※ 20여 곳 이상의 전 세계 공급처에서 천모자, 스트로햇, 휄트햇, 카우보이 햇을 포함한 다양한 스타일의 모자 취급
              </div>
              <div className="eng">
                ※ Headquarters in Dallas, Texas / Branch in Stockton, California
                <br />
                ※ Comprehensive hat sales company
                <br />
                ※  Selling various fashion products(hat related) with various
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;brands to retail markets of the world, including U.S.A.
                <br />
                ※ Handling hats in various styles such as cloth hats, straw hats,
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;felt hats, etc. with more than 20 suppliers in the world
              </div>

            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default SalesCorporation3;
